import { render, staticRenderFns } from "./editFreeEsportsTournament.vue?vue&type=template&id=5fe299ba&"
import script from "./editFreeEsportsTournament.vue?vue&type=script&lang=js&"
export * from "./editFreeEsportsTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports